


























































































































// vue
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

// components
import BaseTable from '@/components/BaseTable.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import SortableTableHeader from '@/components/SortableTableHeader.vue';

// store
import { RoleGroupInfo } from '@/store/modules/role/types/role.types';
import { SortOrder } from '@/store/types/general.types';

@Component({
  components: {
    BaseTable,
    BasePagination,
    SortableTableHeader
  }
})
export default class GroupsRolesAndExceptionsList extends mixins(
  PaginationMixin
) {
  @Prop({ type: Number, default: 1 })
  public totalNumberOfPage!: number;
  @Prop({ type: Number, default: 1 })
  public totalCount!: number;
  @Prop({ type: Boolean, default: false })
  public isFirstPage!: boolean;
  @Prop({ type: Boolean, default: false })
  public isLastPage!: boolean;
  @Prop({ type: Number, default: 1 })
  public startItemIndex!: number;
  @Prop({ type: Number, default: 1 })
  public endItemIndex!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: 'ASC' | 'DESC';
  @Prop({
    type: Array,
    default: []
  })
  public groups!: RoleGroupInfo[];

  editGroup(groupId: number) {
    this.$router.replace({
      name: 'view-group-roles-and-exceptions',
      params: { group_id: String(groupId) }
    });
  }

  onClickHeaderColumn(columnName: string): void {
    const sortSpecs = {
      sortColumn: columnName,
      sortOrder: SortOrder.DESC
    };

    /* invert sort order if the same column is clicked again */
    if (this.sortColumn === columnName) {
      sortSpecs.sortOrder =
        this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
    }

    this.$emit('sort', sortSpecs);
  }

  getSortOrderOfColumn(name: string): string {
    return this.sortColumn === name ? this.sortOrder : SortOrder.ASC;
  }
}
